// @ts-check

import React from 'react';
import { array, func } from 'prop-types';
import sortAddresses from '../libs/sortAddresses';
import ProfilePaper from './ProfilePaper';
import Typography from '@mui/material/Typography';
import ProfileEditorAddress from './ProfileEditorAddress';

/**
 * @component ProfileEditorAddresses
 * @param {Object} props
 * @param {ProfileEditorAddressType[]} props.addresses
 * @param {(name:string, payload: any)=>void} props.onHandle
 * @returns {JSX.Element}
 */
function ProfileEditorAddresses({ addresses, onHandle }) {
	const sortedAddresses = sortAddresses(addresses);

	return (
		<ProfilePaper>
			<Typography variant="button">ADDRESSES</Typography>
			{sortedAddresses.map((address, index) => (
				<ProfileEditorAddress key={index} index={index} address={address} onHandle={onHandle} />
			))}
		</ProfilePaper>
	);
}

ProfileEditorAddresses.propTypes = { addresses: array, onHandle: func };

export default ProfileEditorAddresses;
